import Environment from "./base";

const environments: Environment = {
  isDevelopment: false,
  serviceHostName: "https://service.pantavanij.com",
  clientID: "supplier",
  cookieWow: "https://cookiecdn.com/cwc.js",
  cookieWowDataDomainScript: "SN8L5vyayBZj29evC4fMchqe", // You need to get this from CookieWow for production
  keycloakHostName: "https://service.pantavanij.com/keycloak",
  keycloakRealm: "ptvn",
  supplierFrontend: "https://supplier.pantavanij.com",
  supplierWebWorkFrontend: "https://www.supplierwebwork.com",
  emarketPlaceFrontend: "https://emarketplace.pantavanij.com",
  pantavanijIntelligenceFrontend: "https://emarketplace.pantavanij.com/pi",
  lameSurvayFrontend: "https://saq.pantavanij.com/loginFromSC",
  sqaOneFrontend: "https://saq-one.pantavanij.com/dashboard?userGuid=",
  oneTrust: "https://cdn-apac.onetrust.com",
  oneTrustDataDomainScript: "74c3f702-f397-434c-b05f-eeed9027365a",
  googleAnalyticKey: "G-9M59TXSDHY",
  cocDocumentTH: "https://supplier.pantavanij.com/files/CPGCG-CoC-TH.pdf",
  cocDocumentEN: "https://supplier.pantavanij.com/files/CPGCG-CoC-EN.pdf",
  AccepAutoPOTH: "https://supplier.pantavanij.com/files/Supplier_Auto_Accept_PO_V3_Thai.pdf",
  AccepAutoPOEN: "https://supplier.pantavanij.com/files/Supplier_Auto_Accept_PO_V3_Eng.pdf",
  subOnePOA: "https://poa.pantavanij.com/auth/callback?userGuid=",
  hotjar: {
    siteId: 3564234,
    hotjarVersion: 6,
  }
};

export default environments;
